import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScUiWizardNavComponent } from './scui-wizard-nav.component';

@NgModule({
  declarations: [ScUiWizardNavComponent],
  imports: [
    CommonModule
  ],
  exports: [ScUiWizardNavComponent]
})
export class ScUiWizardNavModule {
}
